import React from 'react';
import { ImportJob, SOURCE_LABELS, STATUS_LABELS } from '../../services/importService';

interface Props { job: ImportJob; onViewErrors?: () => void; onViewChecklist?: () => void; }

const STATUS_COLOR: Record<number, string> = {
  100000000: 'var(--ink-4)',    // Pending
  100000001: 'var(--brand)',    // In progress
  100000002: 'var(--success)',  // Complete
  100000003: 'var(--danger)',   // Failed
  100000004: 'var(--warning)',  // Partial
};

export default function ImportJobCard({ job, onViewErrors, onViewChecklist }: Props) {
  // Migration checklist is offered for imports that reached a terminal state.
  const isTerminal = job.dagrun_pm_status === 100000002 || job.dagrun_pm_status === 100000004;
  return (
    <div className="card" style={{ padding: 14, marginBottom: 8 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
        <strong style={{ fontSize: 13, color: 'var(--ink)' }}>
          {SOURCE_LABELS[job.dagrun_pm_sourcetype] ?? 'Unknown'}
        </strong>
        <span style={{
          padding: '2px 7px',
          background: STATUS_COLOR[job.dagrun_pm_status] ?? 'var(--ink-4)',
          color: '#fff',
          borderRadius: 'var(--r-sm)',
          fontSize: 11,
          fontWeight: 500,
        }}>
          {STATUS_LABELS[job.dagrun_pm_status]}
        </span>
      </div>
      <div style={{ fontSize: 12, color: 'var(--ink-3)' }}>
        {job.dagrun_pm_sourceidentifier || job.dagrun_pm_name}
      </div>
      <div style={{ fontSize: 12, color: 'var(--ink-3)', marginTop: 4, fontFamily: 'var(--font-mono)' }}>
        {job.dagrun_pm_rowsimported ?? 0} / {job.dagrun_pm_rowstotal ?? '?'} imported
        {(job.dagrun_pm_rowsfailed ?? 0) > 0 && (
          <span style={{ color: 'var(--danger)', cursor: 'pointer', marginLeft: 8 }} onClick={onViewErrors}>
            {job.dagrun_pm_rowsfailed} errors
          </span>
        )}
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 4 }}>
        <div style={{ fontSize: 11, color: 'var(--ink-4)' }}>
          {new Date(job.createdon).toLocaleString()}
        </div>
        {isTerminal && onViewChecklist && (
          <button type="button" onClick={onViewChecklist}
            style={{ background: 'transparent', border: 'none', padding: 0, color: 'var(--brand)', fontSize: 12, fontWeight: 600, cursor: 'pointer', fontFamily: 'var(--font-ui)' }}>
            View migration checklist
          </button>
        )}
      </div>
    </div>
  );
}
